import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const countryApi = createApi({
    reducerPath: 'countryApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["Country"],
    endpoints: (builder) => ({
        getCountry: builder.query({
            query: () => `countryList`,
            providesTags: ["Country"],
        }),
        addCountry: builder.mutation({
            query: (newCountry) => ({
                url: 'country',
                method: 'POST',
                body: newCountry,
            }),
            invalidatesTags: ['Country'],
        }),
        deleteCountry: builder.mutation({
            query: ({ id }) => ({
                url: `country/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Country'],
        }),
    }),
})

export const { useGetCountryQuery, useAddCountryMutation, useDeleteCountryMutation } = countryApi